import Layout from '@/components/Layout';
import AreasManager from '@/components/AreasManager';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function AreasManagerPage() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="min-h-screen py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Back Button */}
          <div className="mb-8">
            <button
              onClick={() => navigate('/admin')}
              className="inline-flex items-center gap-2 bg-[#2C1810]/90 text-[#F4E4C1] font-bold px-4 py-2 rounded-lg hover:bg-[#2C1810] transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="text-lg">Back to Admin Dashboard</span>
            </button>
          </div>

          {/* Areas Manager Component */}
          <AreasManager />
        </div>
      </div>
    </Layout>
  );
}
